// 1729 — Turkish UI strings (secondary language)

const tr = {
  giftWord: 'armağan',

  auth: {
    signup: 'Kayıt Ol',
    login: 'Giriş Yap',
    email: 'E-posta',
    password: 'Şifre',
    processing: 'İşleniyor',
    error: 'Bir şey olmadı. Tekrar dener misin?',
    forgotPassword: 'Şifremi unuttum',
    // Reset-password page
    resetTitle: 'Yeni şifre belirle',
    resetSubtitle: 'Hesabın için yeni bir şifre seç.',
    newPassword: 'Yeni şifre',
    confirmPassword: 'Şifreyi onayla',
    updatePassword: 'Şifreyi güncelle',
    passwordUpdated: 'Şifren güncellendi. Şimdi giriş yapabilirsin.',
    passwordMismatch: 'Şifreler eşleşmiyor.',
    resetExpired: 'Bağlantının süresi dolmuş ya da geçersiz. Sıfırlamayı tekrar dene.',
    backToLogin: 'Girişe dön',
    noAccount: 'Hesabın yok mu? Kaydol',
    haveAccount: 'Zaten hesabın var mı? Giriş yap',
    signupInfo: 'Hesabın oluşturuldu. E-postana bir doğrulama linki gönderdik. Linke tıkla, sonra giriş yap.',
  },

  chat: {
    requestTitle: 'İsteğini yaz',
    requestHint: 'Kendini tanıtman gerekmiyor. Ama bu armağanın senin için ne anlama geldiğini ve ne için kullanacağını bir iki cümleyle yazarsan veren kişi içi rahat karar verir.',
    requestPlaceholder: 'Merhaba, bu armağanla ilgileniyorum. Şunun için kullanacağım: ',
    askHint: 'Vermeden önce merak ettiğin bir şey varsa sorabilirsin:',
    askQuestions: ['Bunu ne için kullanacaksın?', 'Bu senin için ne anlama geliyor?', 'Sana nasıl bir fayda sağlar?'],
    send: 'Gönder',
    sending: 'Gönderiliyor',
    placeholder: 'Mesajını yaz',
    empty: 'Henüz mesaj yok.',
    close: 'Kapat',
    closedNote: 'Bu sohbet kapatıldı.',
    markReceived: 'Teslim aldım',
    deliveredNote: 'Teslim alındı.',
    addToCircle: 'Güven çemberine ekle',
    notFound: 'Bu sohbet bulunamadı ya da sana açık değil.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
    inboxTitle: 'Mesajlar',
    inboxEmpty: 'Yeni mesaj yok.',
    inboxAll: 'Tüm sohbetler',
    listTitle: 'Sohbetler',
    listEmpty: 'Henüz sohbet yok.',
    unread: (n) => `${n} yeni`,
    open: 'Sohbet',
  },

  member: {
    back: 'Geri',
    notVisible: 'Bu profil sana açık değil. Profiller yalnızca aynı topluluktaki ya da güven çemberindeki kişilere görünür.',
    you: 'Bu sensin',
    gave: 'Verdiği',
    received: 'Aldığı',
    circle: 'Güven çemberine alan',
    times: (n) => `${n} kez`,
    people: (n) => `${n} kişi`,
    gifts: 'Verdikleri',
    noGifts: 'Şu an yayında armağanı yok.',
    receivedTitle: 'Aldıkları',
    noReceived: 'Henüz bir şey almadı.',
    answers: 'Hakkında',
    aboutMe: 'Hakkımda',
    noAnswers: 'Yanıt yok.',
    openProfile: 'Profili gör',
    whyGive: 'Neden veriyor?',
    request: 'İste',
    requesting: 'Gönderiliyor',
    requested: 'İsteğin gönderildi.',
    ownGift: 'Bu senin armağanın.',
    notFound: 'Bu armağan bulunamadı ya da sana açık değil.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  disaster: {
    tab: 'Afet',
    offerButton: 'Afet için sun',
    modalTitle: 'Afet olursa ne sunabilirsin?',
    intro: 'Bir afet durumunda başkalarına yardım edebileceğin bir şeyi paylaş. Tüm üyeler görebilir ve 7 gün yayında kalır.',
    categoryLabel: 'Ne sunuyorsun?',
    categories: {
      housing: 'Barınma',
      food: 'Yemek ve su',
      transport: 'Ulaşım',
      health: 'Sağlık bilgisi',
      communication: 'İletişim',
      shipping: 'Kargo',
      other: 'Diğer',
    },
    descLabel: 'Ayrıntılar',
    descPlaceholder: 'Örn. İstanbul Kadıköy çevresinde, iki kişiye geçici barınma sağlayabilirim. Hafta sonları müsaitim.',
    descHint: 'Hangi bölge için, ne sunabileceğini ve ne zaman müsait olduğunu yaz. Telefon ya da adres paylaşma, iletişim site içi sohbetle kurulur.',
    minChars: (n, now) => `En az ${n} karakter yaz (şu an ${now}).`,
    publish: 'Yayınla',
    badge: 'Afet',
    daysLeft: (d) => (d > 0 ? `${d} gün kaldı` : 'Süresi doldu'),
    renew: '7 gün uzat',
    report: 'Bildir',
    reported: 'Bildirildi',
    empty: 'Şu an yayında afet gönderisi yok.',
  },

  community: {
    homePage: 'Ana sayfa',
    skip: 'Şimdi değil, önce siteyi gezeyim',
    skipHint: 'Davetleri sonra Güven Çemberi sayfasından gönderebilirsin.',
    defaultName: 'Topluluğum',
    mailSentNote: 'Davet e-postaları gönderildi. Sana da linkleri içeren bir özet e-posta gitti.',
    setupTitle: 'Topluluğunu kur',
    setupSubtitle: 'Burada herkes bir topluluğun içinde. Seninkine bir ad ver ve güvendiğin en az iki kişiyi davet et.',
    nameLabel: 'Topluluk adı',
    namePlaceholder: 'örn. Mahalle, Eski Arkadaşlar',
    durationLabel: 'Davetlilerin erişim süresi',
    months6: '6 ay',
    months12: '12 ay',
    emailsLabel: 'Davet edeceğin kişilerin e-postaları',
    emailsPlaceholder: 'isim1@ornek.com\nisim2@ornek.com',
    emailsHint: (n) => n >= 2 ? `${n} kişi davet edilecek.` : `En az 2 geçerli e-posta gerekli (şu an ${n}). Alt alta ya da virgülle ayır.`,
    invalidEmails: (list) => `Geçersiz adres: ${list}`,
    create: 'Topluluğu kur ve davet gönder',
    creating: 'Kuruluyor',
    needTwo: 'En az 2 geçerli e-posta yazmalısın.',
    partialFail: 'Bazı davetler oluşturulamadı. En az 2 davet gerekiyor, tekrar dene.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
    mailNote: 'Davet e-postası gönderilemediyse linkleri aşağıdan kopyalayıp kendin paylaşabilirsin.',
    done: 'Davetler hazır.',
    copyAll: 'Linkleri kopyala',
    copied: 'Kopyalandı!',
    continue: 'Devam',
    myCommunities: 'Topluluklarım',
    founder: 'Kurucu',
    member: 'Üye',
    unnamed: 'İsimsiz topluluk',
    newCommunity: '+ Yeni topluluk kur',
    newTitle: 'Yeni topluluk',
    save: 'Kur',
    cancel: 'Vazgeç',
    empty: 'Henüz bir topluluğun yok.',
  },

  onboarding: {
    screen1: { headline: 'Burada adın yok. Unvanın yok. Geçmişin yok. Sadece sen varsın.', cta: 'Hazırım' },
    screenVillage: {
      line1: 'Hoş geldin.',
      line2: '1. Sana bir renk verilecek. Burada kimliğin bu. Kendinden ne kadarını paylaşacağın tamamen sana kalmış: istersen istediğin kadar paylaşırsın, istemezsen paylaşmazsın.',
      line3: '2. Sana tek bir soru soracağız: ne verebilirsin? Yanıtından bir armağan kartı oluşacak ve böylece sisteme dahil olacaksın. Daha derin sorular istersen sonra, Panel\'den.',
      line4: '3. Davetle geldiysen bir topluluğun parçasısın. Armağan paylaşımını ve temasını o topluluktaki kişilerle yaparsın.',
      line5: '4. İstersen kendi topluluğunu da kurabilir, kapalı bir armağanlaşma çemberi oluşturabilirsin.',
      cta: 'Başla',
    },
    screen2: {
      question: "Son zamanlarda zamanın nasıl geçtiğini fark etmediğin bir an hangisiydi?",
    },
    screen3: {
      question: "Arkadaşların bir konuda hemen sana danışır. Hangisi?",
    },
    screen4: {
      question: "Birinin sana elini uzatmasını en çok hangi işte isterdin?",
    },
    screen6: {
      explanation: 'Şimdi topluluğuna ne verebileceğini soracağız. Küçük bir topluluktasın ve herkes bir şeyini ortaya koyuyor. Bir gün biri sana geliyor, bir konuda desteğine ihtiyacı var. Sen de bunu kolayca, hatta isteyerek yapabiliyorsun. Topluluğa vereceğin şey işte bu.\n\nYanıtından senin armağan kartın oluşturulacak. Kartı istediğin zaman düzenleyebilir, dilediğin kadar yeni armağan kartı ekleyebilirsin.',
      question: 'Topluluğuna vermekten memnun olacağın, sana da iyi gelen şey nedir?',
      optionalLabel: 'İsteğe bağlı',
      optionalPlaceholder: 'Bunu neden sen veriyorsun, başkası değil?',
      cta: 'Armağanımı Oluştur',
    },
    screen7: { ready: 'Armağanın hazır. Topluluğundakilere böyle görünecek.', cta: 'Devam Et', edit: 'Düzenle' },
    giftQuestion: 'Ne verebilirsin?',
    giftIntro: 'Bir eşyan, bir saatlik zamanın, bir bilgin: elindeki her şey olur. Bir cümle yeter. Kartı istediğin zaman düzenleyebilirsin.',
    skipGift: 'Şimdilik atla, önce gezeyim',
    saveError: 'Armağan kartın oluşturulamadı. Tekrar dener misin?',
    saving: 'Kaydediliyor',
    textareaPlaceholder: 'Buraya yaz.',
  },

  nav: {
    dashboard: 'Panel',
    trustTeam: 'Güven Çemberi',
    explore: 'Keşfet',
    give: 'Ver',
    settings: 'Ayarlar',
    signOut: 'Çıkış',
  },

  tour: {
    label: 'Tanıtım',
    next: 'İleri',
    back: 'Geri',
    skip: 'Atla',
    done: 'Başla',
    replay: 'Tanıtımı tekrar göster',
    steps: [
      { title: 'Hoş geldin', body: 'Burada isim yok. Rengin, sende görünen kodun ve diğer üyelerin seni tanıdığı tek şey. Sadece topluluğundaki insanlar seni görür.', target: null },
      { title: 'Ver', body: 'Verebileceğin bir şeyi bir cümleyle yaz: bir eşyan, bir saatlik zamanın, bir bilgin. Karşılığında hiçbir şey beklenmez.', target: '/give' },
      { title: 'Keşfet', body: 'Topluluğundakilerin verdiği armağanlara bak. İstediğini bulursan "İste"ye bas, sohbet açılır.', target: '/receive' },
      { title: 'Sohbetler', body: 'Biri bir şey isteyince ya da sana yazınca sağ üstteki mektup ikonunda görürsün. Eline ulaşınca "Teslim aldım"a bas, sayaçlara öyle yansır.', target: 'inbox' },
      { title: 'Güven Çemberi', body: 'Buradan tanıdıklarını davet edersin. Bir armağanı aldıktan sonra, güvendiğin kişiyi isteğinle çemberine de ekleyebilirsin.', target: '/trust-team' },
    ],
  },

  dashboard: {
    firstGiftTitle: 'Henüz bir armağanın yok',
    firstGiftBody: 'İlkini eklemek bir cümle sürer. Başkaları verdiğini görünce kendileri de vermeye başlar.',
    firstGiftCta: 'İlk armağanı ekle',
    knowTitle: 'İstersen kendini biraz tanıt',
    knowBody: 'Üç kısa soru. İstediğin kadarını yanıtla, topluluğundakiler seni profilinden biraz daha tanır.',
    knowCta: 'Kendini anlat',
    nickAdd: 'Rumuz ekle',
    nickEdit: 'Değiştir',
    nickSave: 'Kaydet',
    nickCancel: 'Vazgeç',
    nickPlaceholder: 'rumuzun',
    nickHint: 'İsteğe bağlı. Rengin hep görünür, rumuzun bazı yerlerde yanında yazar. Topluluktaki herkes görür.',
    nickError: 'Kaydedilemedi. Biraz sonra tekrar dene.',
    knowLater: 'Şimdi değil',
    activeCards: 'Aktif Armağan',
    supportGiven: 'Verilen Armağan',
    supportReceived: 'Alınan Armağan',
    trustTeamSize: 'Seni güven çemberine alan',
    recentActivity: 'Son Hareketler',
    noActivity: 'Henüz kimse burada değil.',
    gave: 'Bir armağan verdin.',
    received: 'Bir armağan aldın.',
    quickActions: {
      createCard: 'Yeni Armağan',
      createCardDesc: 'Yeni bir armağan kartı oluştur.',
      explore: 'Keşfet',
      exploreDesc: 'Güven çemberinden ve ötesinden armağanlara göz at.',
      editQuestions: 'Soruları Düzenle',
      editQuestionsDesc: 'Cevaplarını güncelle.',
      trustTeam: 'Güven Çemberi',
      trustTeamDesc: 'Güven çemberini ve davetlerini yönet.',
    },
  },

  give: {
    iconAuto: 'Otomatik seçildi',
    iconChange: 'Değiştir',
    iconClose: 'Kapat',
    title: 'Ver',
    subtitle: 'Armağan kartlarını yönet.',
    tabMy: 'Armağanlarım',
    tabHistory: 'Verdiklerim',
    cardActive: 'Açık',
    cardInactive: 'Kapalı',
    newCard: 'Yeni Armağan',
    newCardTitle: 'Yeni Armağan',
    edit: 'Düzenle',
    editTitle: 'Armağanı düzenle',
    save: 'Kaydet',
    statusLive: 'Yayında',
    statusPaused: 'Duraklatıldı',
    visibleTo: 'Görünür',
    pause: 'Duraklat',
    resume: 'Yayına al',
    offerQuestion: 'Ne verebilirsin?',
    offerPlaceholder: 'Örneğin: Evde daha iyi kahve için 30 dakika',
    offerHint: 'Bir eşyan, bir saatlik zamanın, bir bilgin: elindeki her şey olur. Bir ya da iki cümle yeter.',
    examples: [
      { label: 'Kahve dersi', text: 'Evde daha iyi kahve için 30 dakika' },
      { label: 'Bir tencere', text: 'Kullanmadığım bir tencereyi verebilirim' },
      { label: 'Sözleşmene göz atmak', text: 'İmzalamadan önce sözleşmene bir göz atarım' },
    ],
    addGift: 'Armağanı ekle',
    moreOptions: 'Ayrıntıları düzenle',
    lessOptions: 'Ayrıntıları gizle',
    titleAuto: 'Yazdığından otomatik oluşur',
    titleLabel: 'Başlık',
    titleHint: 'Verdiğin şeyi kısa ve somut bir cümleyle yaz. Başlığı okuyan, ne alacağını anlamalı. Örnekler: "Evde daha iyi kahve için 30 dakika", "Sözleşmeni imzalamadan önce bir göz atayım", "Bisiklet bakımı".',
    titlePlaceholder: 'örn. Evde daha iyi kahve için 30 dakika',
    descLabel: 'Açıklama',
    descHint: 'Ne vereceğini ve nasıl vereceğini yaz: süre, yöntem (yüz yüze ya da çevrimiçi), kimler için uygun. Kendini tanıtman gerekmiyor, sadece verdiğin şeyi anlat.',
    descPlaceholder: 'örn. Kahve demlemeyi çok severim. Evindeki malzemelerle daha iyi kahve yapmanın yollarını birlikte deneriz. Çevrimiçi ya da yüz yüze olabilir.',
    // Armağan türü
    giftTypeLabel: 'Tür',
    typeUnlimited: 'Sürekli açık',
    typeUnlimitedHint: 'Sınır yok, her zaman geçerli.',
    typeQuota: 'Kotası olan',
    typeQuotaHint: 'Belirli sayıda kullanım.',
    typeOnce: 'Tek seferlik',
    typeOnceHint: 'Bir kişi alır, kapanır.',
    quotaLabel: 'Kaç adet?',
    // Fiziksel/Dijital
    physicalLabel: 'Format',
    digital: 'Dijital',
    physical: 'Fiziksel',
    deliveryNoteLabel: 'Teslimat notu',
    deliveryNotePlaceholder: 'Kargo veya teslimat hakkında bilgi vermek ister misin? (isteğe bağlı)',
    deliveryNoteHint: 'Lojistik detaylar sohbet içinde karşılıklı halledilir, 1729 koordine etmez.',
    // Görünürlük
    visibilityLabel: 'Görünürlük',
    visTrustCircle: 'Güven Çemberi',
    visCommunity: 'Topluluk',
    visGlobal: 'Global',
    comingSoon: 'Yakında',
    // Diğer
    whyMeLabel: 'Neden veriyorsun?',
    whyMeHint: 'Bunu vermenin senin için ne anlama geldiğini yaz. Başkalarıyla kıyaslaman gerekmiyor, sadece senin için değerini anlat.',
    whyMePlaceholder: 'Bunu vermek senin için ne anlama geliyor, sana ne hissettiriyor?',
    optional: 'isteğe bağlı',
    create: 'Oluştur',
    cancel: 'Vazgeç',
    creating: 'Oluşturuluyor',
    empty: 'Henüz bir armağan yok.',
    historyEmpty: 'Henüz kimseye armağan vermedin.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
    // Kart rozetleri
    badgeUnlimited: 'Sürekli',
    badgeOnce: 'Tek seferlik',
    badgeQuota: (n) => `${n} adet kaldı`,
    badgePhysical: 'Fiziksel',
    interested: (n) => n === 1 ? '1 talep' : `${n} talep`,
  },

  explore: {
    newBadge: 'Yeni',
    title: 'Keşfet',
    subtitle: 'Güven çemberinden ve ötesinden armağanlara göz at.',
    tabFeed: 'Armağanlar',
    tabHistory: 'Aldıklarım',
    filterTrustCircle: 'Güven Çemberi',
    filterCommunity: 'Topluluk',
    filterGlobal: 'Global',
    filterAll: 'Tümü',
    filterUnlimited: 'Sürekli',
    filterQuota: 'Kotası olan',
    filterOnce: 'Tek seferlik',
    filterPhysical: 'Fiziksel',
    requestSupport: 'İste',
    requesting: 'Gönderiliyor',
    empty: 'Henüz kimse burada değil.',
    historyEmpty: 'Henüz armağan almadın.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
    markReceived: 'Teslim aldım',
    addToCircle: 'Güven çemberine ekle?',
    addToCircleHint: 'Bu kişiden armağan aldın. Güven çemberine eklemek ister misin?',
    addToCircleYes: 'Ekle',
    addToCircleSkip: 'Geç',
    added: 'Eklendi.',
    comingSoon: 'Yakında',
    // Filter row
    typeLabel: 'Tür',
    // Empty-state card
    emptyCircleTitle: 'Bu çember henüz boş.',
    emptyCircleText: 'İlk armağanı sen sun. Verdiğinde çember canlanır.',
    emptyOtherTitle: 'Burada henüz armağan yok.',
    emptyOtherText: 'İlk sunan sen ol.',
    offerGift: 'Armağan sun',
  },

  questions: {
    title: 'Beni tanı',
    subtitle: 'Burada adın yok. Ama istersen topluluğundaki insanlar seni biraz tanıyabilir: kendini ne kadar açacağın tamamen sana kalmış. Yanıtlamak istediklerini yanıtla, istemediğini boş bırak. Yanıtlarını, aynı topluluktaki üyeler senin renginin profilinde görür.',
    save: 'Kaydet',
    saving: 'Kaydediliyor',
    saved: 'Kaydedildi.',
    createCardLabel: 'Bu cevaptan armağan kartı oluştur.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  trustTeam: {
    title: 'Güven Çemberi',
    subtitle: 'Güven çemberin ve davet ettiklerin.',
    tabCircle: 'Güven Çemberi',
    tabInvited: 'Davet Ettiklerim',
    invite: 'Davet Et',
    emptyCircle: 'Güven çemberin boş.',
    emptyCircleHint: 'Bir armağan aldıktan sonra "teslim aldım" diyerek o kişiyi buraya ekleyebilirsin.',
    emptyInvited: 'Henüz kimseyi davet etmedin.',
    subscriptionActive: 'Aktif',
    subscriptionEnded: 'Sona erdi',
    subscriptionPending: 'Beklemede',
    daysLeft: (n) => `${n} gün kaldı`,
    inCommunity: 'Topluluk',
    alreadyInvited: 'Zaten davet edilmiş',
    copyLinkShort: 'Linki kopyala',
    resend: 'Tekrar gönder',
    sentShort: 'Gönderildi',
    sendFailed: 'Gönderilemedi',
    endSubscription: 'Sonlandır',
    gaveGift: 'sana armağan verdi',
    modal: {
      title: 'Birini davet et',
      step1: 'E-postası',
      step2: 'Süre',
      step3: 'Topluluk',
      step4: 'Davet',
      emailLabel: 'E-posta adresi',
      emailPlaceholder: 'isim@ornek.com',
      duration1: '1 ay',
      duration6: '6 ay',
      duration12: '12 ay',
      communityNew: 'Yeni topluluk',
      communityGeneral: 'Genel (topluluksuz)',
      communityExisting: 'Mevcut topluluk',
      communityNameLabel: 'Topluluk adı',
      membersAwareLabel: 'Üyeler bir isimli grubun parçası olduklarını bilsin',
      next: 'Devam',
      back: 'Geri',
      generate: 'Davet Oluştur',
      linkReady: 'Davet linkini paylaş',
      linkHint: 'Bu linke tıklayıp şifre belirleyerek katılabilirler.',
      codeBackupLabel: 'Yedek kod',
      copyLink: 'Linki kopyala',
      copy: 'Kopyala',
      copied: 'Kopyalandı!',
      close: 'Tamam',
      // Bulk invite
      bulkLabel: 'E-postalar (her satıra bir tane)',
      bulkPlaceholder: 'isim1@ornek.com\nisim2@ornek.com\nisim3@ornek.com',
      bulkSwitchMany: 'Birden fazla',
      bulkSwitchSingle: 'Tek kişi',
      bulkHint: (n) => `${n} kişi davet edilecek.`,
      bulkSubject: (n) => `${n} kişi`,
      bulkReady: (n) => `${n} davet hazır`,
      sentNote: 'Davet e-postaları gönderildi. İstersen linkleri kendin de paylaşabilirsin.',
      copyAll: 'Tümünü kopyala',
    },
  },

  communityLink: {
    title: 'Katılım linki',
    hint: 'Linki açan herkes hesap oluşturup bu topluluğa katılabilir. Link, kimin oluşturduğunu göstermez. İstediğin zaman kapatabilir ya da yenileyebilirsin.',
    create: 'Link oluştur',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    on: 'Aç',
    off: 'Kapat',
    renew: 'Yenile',
    renewConfirm: 'Eski link çalışmayacak. Yenilensin mi?',
    isOff: 'Link şu an kapalı.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  joinCommunity: {
    title: (name) => `${name} topluluğuna katıl`,
    subtitle: 'Bir davet linkiyle geldin. Burada isim yok, herkes bir renk.',
    signup: 'Hesap oluştur ve katıl',
    login: 'Zaten hesabım var',
    join: 'Katıl',
    joining: 'Katılıyorsun',
    invalid: 'Bu link geçersiz ya da kapatılmış.',
    home: 'Ana sayfa',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  about: {
    what: 'Bu nedir? Manifestoyu oku',
    footerHome: '1729 nedir?',
    footerManifesto: 'Manifesto',
    footerPricing: 'Fiyat',
    footerContact: 'İletişim',
  },

  announce: {
    title: 'Duyurular',
    new: 'yeni',
    viewAll: 'Tümünü gör',
    composeTitle: 'Duyuru yaz',
    hint: 'Topluluğunun tüm üyelerine gider. Kimin yazdığı görünmez. Günde en fazla bir duyuru.',
    hintSystem: '#1729 imzasıyla herkese gider.',
    placeholder: 'Duyurunu yaz',
    send: 'Gönder',
    sending: 'Gönderiliyor',
    alsoEmail: 'E-posta olarak da gönder (haftada en fazla bir)',
    alsoEmailSystem: 'Önemli: e-posta olarak da gönder',
    sent: 'Gönderildi.',
    sentEmailOff: 'Duyuru gönderildi. E-posta şu an kapalı, yalnızca sitede görünür.',
    sentEmailFailed: 'Duyuru gönderildi ama e-posta gönderilemedi.',
    tooSoon: 'Bugün zaten bir duyuru gönderdin. Yarın tekrar dene.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  join: {
    browserNote: "Giriş yapamıyorsan ya da ekran boş kalıyorsa, linki Chrome ya da Safari'de aç.",
    title: '1729\'a katıl',
    subtitle: 'Davet edildin. Şifreni belirle, içeri gir.',
    invitedAs: 'Davet edilen e-posta',
    passwordLabel: 'Şifre belirle',
    passwordPlaceholder: '••••••••',
    cta: 'Katıl',
    joining: 'Katılıyorsun',
    invalidInvite: 'Bu davet geçersiz ya da daha önce kullanılmış.',
    confirmEmail: 'Hesabın oluşturuldu. E-postana bir doğrulama linki gönderdik. Linke tıkla, sonra giriş yap.',
    haveAccount: 'Zaten hesabın var mı? Giriş yap',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  payment: {
    title: '1729\'a Katıl',
    subtitle: 'Devam etmek için davet kodu gerekli.',
    codeLabel: 'Davet kodu',
    codePlaceholder: 'XXXXXX',
    apply: 'Uygula',
    invalidCode: 'Geçersiz veya kullanılmış kod.',
    codeAccepted: 'Kod kabul edildi.',
    requireCode: 'Davet kodu gereklidir.',
    continue: 'Devam Et',
    processing: 'İşleniyor',
    testMode: 'Test modu: gerçek ödeme alınmıyor.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  settings: {
    title: 'Ayarlar',
    subtitle: 'Hesap ve tercihlerini yönet.',

    // Görünüm
    appearance: 'Görünüm & Dil',
    theme: 'Tema',
    themeDark: 'Koyu',
    themeLight: 'Açık',
    themeSystem: 'Sistem',
    language: 'Dil',
    giftWord: 'Armağan kelimesi',
    giftWordDefault: 'Armağan',
    giftWordAlt: 'Şey',
    giftWordNote: 'Bu tercih sadece sana özel. Başkaları her zaman kendi tercihlerinde görür.',

    // Abonelik
    subscription: 'Abonelik',
    plan: 'Plan',
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
    daysLeft: (n) => `${n} gün kaldı`,
    type: 'Tür',
    typeGifted: 'Birinin hediyesi',
    typeSelf: 'Kendi aboneliği',
    managePayment: 'Ödemeyi yönet',
    comingSoon: 'Yakında',

    // Bildirimler
    notifications: 'E-posta bildirimleri',
    notifGiftInterest: 'Birileri armağanınla ilgilendi',
    notifGiftInterestHint: 'Armağanın etrafında bir sohbet başladığında.',
    notifNewMessage: 'Yeni mesaj',
    notifNewMessageHint: 'Aktif bir sohbette yeni mesaj aldığında.',
    notifAnnouncements: 'Duyuru e-postaları',
    notifAnnouncementsHint: 'Topluluğundan ya da 1729\'dan gelen duyuruları e-postayla da alırsın. Kapalıysa duyurular yalnızca sitede görünür.',
    notifShowPreview: 'E-postada mesaj içeriğini göster',
    notifShowPreviewHint: 'Kapalıysa e-posta sadece "yeni mesajın var" der, metni göstermez.',
    notifSubExpiring: 'Abonelik bitiyor',
    notifSubExpiringHint: 'Erişimin bitmesine 5 gün kala.',
    notifSubExpired: 'Abonelik sona erdi',
    notifSubExpiredHint: 'Erişimin sona erdiğinde.',
    notifAddedToCircle: 'Birisinin çemberine eklendin',
    notifAddedToCircleHint: 'Biri seni güven çemberine eklediğinde.',
    notifQuotaEmpty: 'Armağan kotası doldu',
    notifQuotaEmptyHint: 'Kotası olan bir armağan tükendiğinde.',

    // Hesap
    account: 'Hesap',
    emailLabel: 'E-posta adresi',
    changePassword: 'Şifre değiştir',
    newPassword: 'Yeni şifre',
    updatePassword: 'Güncelle',
    passwordUpdated: 'Şifre güncellendi.',
    dangerZone: 'Tehlikeli bölge',
    deleteAccount: 'Hesabını ve tüm verilerini kalıcı olarak sil.',
    deleteConfirmPlaceholder: 'Silmek için SİL yaz',
    deleteConfirmWord: 'SİL',
    confirmDelete: 'Kalıcı olarak sil',

    saved: 'Kaydedildi.',
    error: 'Bir şey olmadı. Tekrar dener misin?',
  },

  language: { label: 'Dil', en: 'English', tr: 'Türkçe' },

  errors: {
    generic: 'Bir şey olmadı. Tekrar dener misin?',
    dbError: 'Bağlantı kurulamadı.',
  },
}

export default tr
